import { Box, Text } from '@qga/roo-ui/components';
import shouldUpdatePaymentMethod from 'pages/BookingListPage/utils/shouldUpdatePaymentMethod';
import { ListBooking } from 'types';

interface BookingStatusConfig {
  status?: string;
  bg?: string;
}

const statusProps = {
  booked: {
    status: 'CONFIRMED',
    bg: 'lightGreen',
  },
  changesInProgress: {
    status: 'CHANGES IN PROGRESS',
    bg: 'lightBlue',
  },
  finalizing: {
    status: 'FINALISING',
    bg: 'lightBlue',
  },
  blocked: {
    status: 'BLOCKED',
    bg: 'lightOrange',
  },
  actionRequired: {
    status: 'ACTION REQUIRED',
    bg: 'lightOrange',
  },
};

const getBookingStatusProps = (booking: ListBooking): BookingStatusConfig => {
  if (booking.reservation.isAfterCheckOut) {
    return {};
  }

  const { isChangeInProgress, isBlocked, isFinalising, isBooked } = booking.flags;

  if (isChangeInProgress) {
    return statusProps.changesInProgress;
  } else if (isBlocked) {
    return statusProps.blocked;
  } else if (isFinalising) {
    return statusProps.finalizing;
  } else if (shouldUpdatePaymentMethod(booking)) {
    return statusProps.actionRequired;
  } else if (isBooked) {
    return statusProps.booked;
  } else {
    return {};
  }
};

interface BookingStatusProps {
  booking: ListBooking;
}

export const BookingStatus = ({ booking }: BookingStatusProps) => {
  const props = getBookingStatusProps(booking);

  if (props.status) {
    return (
      <Box>
        <Text fontSize={14} px={2} py="2px" color="greys.mineShaft" {...props}>
          {props.status}
        </Text>
      </Box>
    );
  }

  return null;
};
